<template>
    <v-container grid-list-xl fluid>
        <v-layout row wrap>
            <v-flex lg12>
                <v-card>
                    <hpo-filter :headers="headers" :viewName="viewName" v-on:applyFilter="applyFilter" v-on:quickFilter="quickFilter"></hpo-filter>
                    <v-data-table :headers="headers" :items="items" :options.sync="pagination" :server-items-length="total_rows" :footer-props="items_per_page" :must-sort="true" :loading="loading" :mobile-breakpoint="100">
                        <template v-slot:item="{ item }">
                            <tr>
                                <td>{{ item.id }}</td>
                                <td>{{ item.phone }}</td>
                                <td>{{ item.first_name }}</td>
                                <td>{{ item.email }}</td>
                                <td v-bind:style="{ 'color': item.is_active == 1 ? '#0059b3' : '#e63900'}">{{ item.is_active == 1 ? 'Kích hoạt' : 'Đã khóa' }}</td>
                                <td>
                                    <v-edit-dialog
                                        :return-value.sync="item.sale_id"
                                        large
                                        lazy
                                        persistent
                                        @save="saveItem({'id': item.id, 'sale_id': item.sale_id})"
                                    >
                                        <div>{{ item.sale_id | display_value(sales, 'id', 'first_name') }}</div>
                                        <template v-slot:input>
                                        <v-select
                                            :items="sales"
                                            v-model="item.sale_id"
                                            item-text="first_name"
                                            item-value="id"
                                        ></v-select>
                                        </template>
                                    </v-edit-dialog>
                                </td>
                                <td class="text-right">{{ item.total_recharge | currency }}</td>
                                <td class="text-right">{{ item.total_amount | currency }}</td>
                                <td class="text-right">{{ item.total_return | currency }}</td>
                                <td class="text-right">{{ item.total_debt | currency }}</td>
                                <td class="text-center">
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on }">
                                            <v-icon medium class="mr-2" color="red" @click="resetPassword(item.id)" v-on="on">autorenew</v-icon>
                                        </template>
                                        <span>Reset mật khẩu về mặc định</span>
                                    </v-tooltip>
                                    <v-icon medium class="mr-2" @click="openItem(item.id)">edit</v-icon>
                                    <v-icon medium :disabled="item.id == 1" @click="deleteItem(item.id)">delete</v-icon>
                                </td>
                            </tr>
                        </template>
                    </v-data-table>
                </v-card>
            </v-flex>
        </v-layout>
        <v-dialog v-model="dialogItem" max-width="800px">
          <v-card>
            <v-tabs v-model="tab" background-color="primary" dark>
                <v-tab>Tài khoản</v-tab>
                <v-tab>Xuất hàng</v-tab>
                <v-tab>Trả hàng</v-tab>
                <v-tab>Thanh toán</v-tab>
            </v-tabs>
            <v-tabs-items v-model="tab">
                <v-tab-item>
                    <v-card flat>
                        <v-container grid-list-md pa-4>
                            <v-layout row wrap>
                                <v-flex lg12>
                                    <v-text-field label="Tài khoản" v-model="currentItem.phone" class="input-group--focused"></v-text-field>
                                </v-flex>
                                <v-flex lg12 v-if="!currentItem.id">
                                    <v-text-field label="Mật khẩu" v-model="currentItem.password" class="input-group--focused"></v-text-field>
                                </v-flex>
                                <v-flex lg12>
                                    <v-text-field label="Họ tên" v-model="currentItem.first_name" class="input-group--focused"></v-text-field>
                                </v-flex>
                                <v-flex lg12>
                                    <v-text-field label="Email" v-model="currentItem.email" class="input-group--focused"></v-text-field>
                                </v-flex>
                                <v-flex lg12>
                                    <v-text-field label="Địa chỉ" v-model="currentItem.address" class="input-group--focused"></v-text-field>
                                </v-flex>
                                <v-flex lg12>
                                    <v-switch label="Kích hoạt" v-model="currentItem.is_active" class="input-group--focused"></v-switch>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-card>
                </v-tab-item>
                <v-tab-item>
                    <v-card flat>
                        <h-receipts :customer_id="currentItem.id" v-if="dialogItem && tab == 1"></h-receipts>
                    </v-card>
                </v-tab-item>
                <v-tab-item>
                    <v-card flat>
                        <h-returns :customer_id="currentItem.id" v-if="dialogItem && tab == 2"></h-returns>
                    </v-card>
                </v-tab-item>
                <v-tab-item>
                    <v-card flat>
                        <h-recharges :customer_id="currentItem.id" v-if="dialogItem && tab == 3"></h-recharges>
                    </v-card>
                </v-tab-item>
            </v-tabs-items>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="red darken-1 white--text" @click="dialogItem = false">Đóng</v-btn>
              <v-btn @click="editItem">Cập nhật</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
    </v-container>
    </template>
    
    <script>
    import { mapState } from "vuex";
    import configs from "@/configs";
    import Filtering from "@/components/Filtering";
    import Receipts from "@/views/Receipts/list";
    import Returns from "@/views/Returns/list";
    import Recharges from "@/views/Recharges/list";
    import _ from "lodash";
    
    export default {
        components: {
            "hpo-filter": Filtering,
            "h-receipts": Receipts,
            "h-returns": Returns,
            "h-recharges": Recharges,
        },
        data() {
            return {
                viewName: "user_list",
                dialogItem: false,
                headers: [{
                        text: "ID",
                        value: "id",
                        filterable: true,
                        dataType: configs.DATA_TYPE["Number"]
                    },
                    {
                        text: "Tài khoản",
                        value: "phone",
                        filterable: true,
                        quickSearch: true,
                        dataType: configs.DATA_TYPE["String"]
                    },
                    {
                        text: "Họ tên",
                        value: "first_name",
                        filterable: true,
                        quickSearch: true,
                        dataType: configs.DATA_TYPE["String"]
                    },
                    {
                        text: "Email",
                        value: "email",
                        filterable: true,
                        quickSearch: true,
                        dataType: configs.DATA_TYPE["String"]
                    },
                    {
                        text: "Trạng thái",
                        value: "is_active",
                        filterable: true,
                        dataType: configs.DATA_TYPE["Number"]
                    },
                    {
                        text: "Sale",
                        value: "sale_id",
                        filterable: true,
                        values: [],
                        dataType: configs.DATA_TYPE["Enum"]
                    },
                    {
                        text: "Thanh toán",
                        value: "total_recharge",
                        filterable: true,
                        align: "end",
                        dataType: configs.DATA_TYPE["Number"]
                    },
                    {
                        text: "Tiền hàng",
                        value: "total_amount",
                        filterable: true,
                        align: "end",
                        dataType: configs.DATA_TYPE["Number"]
                    },
                    {
                        text: "Trả hàng",
                        value: "total_return",
                        filterable: true,
                        align: "end",
                        dataType: configs.DATA_TYPE["Number"]
                    },
                    {
                        text: "Công nợ",
                        value: "total_debt",
                        filterable: true,
                        align: "end",
                        dataType: configs.DATA_TYPE["Number"]
                    },
                    {
                        text: "",
                        value: "",
                        align: "center",
                        sortable: false,
                        filterable: false
                    }
                ],
                pagination: _.cloneDeep(configs.PAGINATION),
                items_per_page: _.cloneDeep(configs.ITEMS_PER_PAGE),
                filterConditions: [],
                quickFilterConditions: [],
                requireRules: [v => !!v || "Trường dữ liệu không được để trống."],
                tab: null
            };
        },
        watch: {
            pagination: {
                handler: function (val, oldVal) {
                    let filterConditions = this.$store.state.commons.filterConditions;
                    this.filterConditions = !_.isEmpty(filterConditions) ? filterConditions[this.viewName] : []
                    this.filter_data();
                },
                deep: true
            },
            sales() {
                let header_item = _.find(this.headers, { value: "sale_id" });
                if (header_item) {
                    header_item.values =
                    _.map(this.sales, (item) => {
                        return {
                            value: item.id,
                            name: item.first_name,
                        };
                    }) || [];
                }
            }
        },
        computed: {
            ...mapState({
                items: state => state.users.all.data,
                total_rows: state => state.users.all.total,
                loading: state => state.users.loading,
                currentItem: (state) => state.users.selected,
                sales: state => state.users.sale.data,
            }),
            role_list() {
                return _.filter(configs.ROLES, (p) => {return p.value == configs.ROLE_TYPE.Customer});
            }
        },
        methods: {
            getSaleList() {
                let param = {
                    filter: [{column: 'role', value: [configs.ROLE_TYPE.Staff, configs.ROLE_TYPE.Admin], condition: "in"}]
                }
                this.$store.dispatch("users/getSale", param);
            },
            filter_data: function () {
                var param = {
                    pagination: this.pagination,
                    filter: [...this.filterConditions],
                    quickFilter: this.quickFilterConditions
                };
                param.filter.push({column: 'role', value: configs.ROLE_TYPE.Customer, condition: "equal"});
                this.$store.dispatch("users/getList", param);
                this.getSaleList();
            },
            applyFilter(filterConditions) {
                let sortBy = this.pagination.sortBy
                let sortDesc = this.pagination.sortDesc
                this.pagination = configs.PAGINATION;
                this.pagination.sortBy = sortBy;
                this.pagination.sortDesc = sortDesc;
                this.filterConditions = filterConditions;
                this.filter_data();
            },
            quickFilter(filterConditions) {
                this.quickFilterConditions = filterConditions;
                this.filter_data();
            },
            openItem: function (id) {
                if(!id) {
                    this.$store.commit("users/setDetail", {'id': id});
                }
                else {
                    this.$store.dispatch("users/getDetail", id);
                }
                this.dialogItem = true;
            },
            deleteItem: function(id) {
                window.getApp.$emit('REQUEST_DELETE_DATA', id);
            },
            editItem() {
                let payload = {
                        'phone': this.currentItem.phone,
                        'first_name': this.currentItem.first_name,
                        'email': this.currentItem.email,
                        'is_active': this.currentItem.is_active,
                        'address': this.currentItem.address,
                        role: configs.ROLE_TYPE.Customer
                    }
                if(!this.currentItem.id) {
                    payload.password = this.currentItem.password
                }
                this.$store.dispatch("users/setDetail", {
                    'data': payload,
                    'id': this.currentItem.id
                });
                this.dialogItem = false;
            },
            resetPassword: function(id) {
                this.$store.dispatch("users/setDetail", {
                    'data': {password: '12345678'},
                    'id': id,
                    'notify': 'Đã reset mật khẩu về mặc định (12345678)'
                });
            },
            saveItem(item) {
                this.$store.dispatch("users/setDetail", {
                    data: {...item},
                    id: item.id
                });
            },
        },
        mounted() {
            this.$root.$emit('REQUEST_ROOT_OPTION', {});
            this.$root.$on("REQUEST_CREATE_DATA", this.openItem);
            this.$root.$on("REQUEST_REFRESH_DATA", this.filter_data);
            this.$root.$on("CONFIRMED_REMOVE_DATA", id => {
                this.$store.dispatch("users/removeDetail", id);
            });
        },
        beforeDestroy() {
            this.$root.$off("REQUEST_CREATE_DATA", this.openItem);
            this.$root.$off("REQUEST_REFRESH_DATA", this.filter_data);
            this.$root.$off("CONFIRMED_REMOVE_DATA");
        }
    };
    </script>
    